/* Cadoul câștigat în popup („Reducere surpriză”, modul cadou) — coșul:
   - bară „Mai adaugă X lei și primești gratuit [cadoul]” în coșul lateral și pe pagina de coș;
   - la ≥ pragul setat (fără cadou), cadoul se adaugă singur (proprietatea _osm_gift), iar sub prag iese din coș;
   - codul personal (BXGY) îl face gratuit; dacă lipsește din coș, îl aplicăm din nou.
   Datele vin din localStorage, salvate de popup când se dezvăluie cadoul. */
(() => {
  if (window.__osmGiftCart) return;
  window.__osmGiftCart = true;

  const me = document.currentScript;
  const prefix = 'osm:' + ((me && me.dataset.campaign) || 'v1') + ':';
  const MIN = Math.round(Number((me && me.dataset.min) || 400) * 100);
  const get = (k) => { try { return localStorage.getItem(prefix + k); } catch (e) { return null; } };
  // venit din emailul cu cadoul (alt dispozitiv): ?osm_gift=<variantă>&osm_gt=<nume>&osm_code=<cod> → reținem cadoul aici
  try {
    const q = new URLSearchParams(location.search);
    const gv = q.get('osm_gift'), gc = (q.get('osm_code') || '').toUpperCase();
    if (/^\d{6,20}$/.test(gv || '') && /^CADOU-[A-Z0-9]{4,12}$/.test(gc)) {
      localStorage.setItem(prefix + 'prize_variant', gv);
      localStorage.setItem(prefix + 'prize_code', gc);
      if (q.get('osm_gt')) localStorage.setItem(prefix + 'prize_title', q.get('osm_gt').slice(0, 80));
      localStorage.setItem('osm:subscriber', '1'); // e deja abonat: popup-ul nu-i mai apare
    }
  } catch (e) { /* fără localStorage: codul rămâne aplicat din link */ }
  let variant = Number(get('prize_variant'));
  let title = get('prize_title') || 'cadoul tău';
  let code = get('prize_code') || get('code');

  const css = document.createElement('style');
  css.textContent = '.osm-gift-bar{box-sizing:border-box;width:100%;margin:0 0 10px;padding:8px 12px 9px;border:1px dashed rgb(255 105 0/.45);border-radius:8px;background:rgb(255 105 0/.06)}'
    + '.osm-gift-bar.is-unlocked{border-style:solid;background:rgb(255 105 0/.12)}'
    + '.osm-gift-bar__text{margin:0 0 6px;font-size:13px;line-height:1.35;text-align:center;color:inherit}'
    + '.osm-gift-bar__track{height:5px;border-radius:999px;background:rgb(0 0 0/.1);overflow:hidden}'
    + '.osm-gift-bar__fill{display:block;height:100%;border-radius:999px;background:#ff6900;transition:width .25s ease}';
  document.head.appendChild(css);

  const money = (cents) => (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  let busy = false;
  let last = null;

  function render(state) {
    last = state;
    const html = state.unlocked
      ? '<span aria-hidden="true">🎁</span> <strong>' + esc(title) + '</strong> — cadoul tău din joc e în coș, <strong>gratuit</strong>!'
      : '<span aria-hidden="true">🎁</span> Mai adaugă <strong>' + money(state.remaining) + '</strong> și primești <strong>gratuit</strong>: <strong>' + esc(title) + '</strong>';
    const pct = Math.max(4, Math.min(100, Math.round((state.subtotal / MIN) * 100)));
    // o singură bară pe loc: în coșul lateral (lista de produse) și pe pagina de coș (deasupra produselor)
    const page = document.querySelector('main .cart-items__wrapper') || document.querySelector('main cart-items-component');
    const targets = [...document.querySelectorAll('cart-drawer-component .cart-drawer__items')].concat(page ? [page] : []);
    document.querySelectorAll('.osm-gift-bar').forEach((b) => { if (!targets.includes(b.parentElement)) b.remove(); });
    targets.forEach((host) => {
      let bar = host.querySelector(':scope > .osm-gift-bar');
      if (!state.show) { if (bar) bar.remove(); return; }
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'osm-gift-bar';
        bar.innerHTML = '<p class="osm-gift-bar__text"></p><div class="osm-gift-bar__track"><span class="osm-gift-bar__fill"></span></div>';
        const after = host.querySelector(':scope > .xs-bar-clone');
        if (after) after.insertAdjacentElement('afterend', bar); else host.prepend(bar);
      }
      // actualizăm doar ce s-a schimbat, ca observatorul de mai jos să nu intre în buclă
      if (bar.classList.contains('is-unlocked') !== state.unlocked) bar.classList.toggle('is-unlocked', state.unlocked);
      const txt = bar.querySelector('.osm-gift-bar__text');
      if (txt.innerHTML !== html) txt.innerHTML = html;
      const w = (state.unlocked ? 100 : pct) + '%';
      const fill = bar.querySelector('.osm-gift-bar__fill');
      if (fill.style.width !== w) fill.style.width = w;
    });
  }

  const post = (url, body) => fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  const notifyTheme = (cart) => document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'osm-gift', data: { source: 'osm-gift', itemCount: cart.item_count } } }));

  async function evaluate() {
    if (busy) return;
    busy = true;
    try {
      let cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const gift = cart.items.find((i) => i.variant_id === variant && i.properties && i.properties._osm_gift);
      const subtotal = cart.items.filter((i) => i !== gift).reduce((t, i) => t + i.original_line_price, 0);
      const unlocked = subtotal >= MIN;
      let changed = false;
      if (unlocked && !gift) {
        await post('/cart/add.js', { items: [{ id: variant, quantity: 1, properties: { _osm_gift: '1' } }] });
        changed = true;
      } else if (!unlocked && gift) {
        await post('/cart/change.js', { id: gift.key, quantity: 0 });
        changed = true;
      }
      if (unlocked && !(cart.discount_codes || []).some((d) => d.code.toUpperCase() === code.toUpperCase())) {
        await fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' });
        changed = true;
      }
      if (changed) {
        cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
        notifyTheme(cart);
      }
      render({ show: cart.item_count > 0, unlocked, remaining: Math.max(0, MIN - subtotal), subtotal });
    } catch (e) {
      /* coșul merge și fără bară */
    } finally {
      busy = false;
    }
  }

  let t = null;
  const later = (ms) => { clearTimeout(t); t = setTimeout(evaluate, ms || 350); };
  function start() {
    document.addEventListener('cart:update', (e) => { if (!(e.detail && e.detail.sourceId === 'osm-gift')) later(); });
    // după re-randarea coșului (morph), bara poate dispărea: o punem la loc din ultima stare
    let raf = 0;
    new MutationObserver(() => {
      if (raf || !last || !last.show) return;
      raf = requestAnimationFrame(() => { raf = 0; render(last); });
    }).observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => later(50)); else later(50);
  }

  // Cadoul nu e memorat pe acest dispozitiv (ex. a venit din emailul cu codul): îl aflăm după codul CADOU-… aplicat în coș.
  async function fromCartCode() {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    const c = (cart.discount_codes || []).map((d) => String(d.code || '').toUpperCase()).find((x) => /^CADOU-[A-Z0-9]{4,12}$/.test(x));
    if (!c) return false;
    const r = await fetch('/apps/favorite/popup-prize?code=' + encodeURIComponent(c), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((x) => x.json());
    if (!r || !r.ok || !/^\d{6,20}$/.test(String(r.variant))) return false;
    variant = Number(r.variant); title = r.title || title; code = c;
    try {
      localStorage.setItem(prefix + 'prize_variant', String(r.variant));
      localStorage.setItem(prefix + 'prize_title', title);
      localStorage.setItem(prefix + 'prize_code', c);
      localStorage.setItem('osm:subscriber', '1');
    } catch (e) { /* merge și fără memorare */ }
    return true;
  }

  if (variant && code) start();
  else if (/(?:^|;\s*)discount_code=CADOU-/i.test(document.cookie)) fromCartCode().then((ok) => { if (ok) start(); }).catch(() => {});
})();
